var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgChevronRight = function SvgSvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.998a1.998 1.998 0 0 1-1.414-3.414l6.61-6.61L.837 3.39A2.002 2.002 0 0 1 3.716.609l7.723 8a2 2 0 0 1-.024 2.803l-8 8c-.39.39-.901.587-1.413.587Z",
    fill: "currentColor"
  })));
};
export default SvgSvgChevronRight;